import React, { createContext, Dispatch, SetStateAction } from "react";
import { useSelector } from "react-redux";
import { selectNavType, NavType, selectNavData } from "reducers/navbar";
import { LoggedInNavBar } from "./LoggedInNavBar";
import { LoginNavBar } from "./LoginNavBar";

interface NavBarProps {
  isThemed: boolean;
  setMobileNavOpen: Dispatch<SetStateAction<boolean>>;
  mobileNavOpen: boolean;
}

export const NavBarContext = createContext<boolean | null>(null);

export const NavBar: React.FC<NavBarProps> = ({
  isThemed,
  setMobileNavOpen,
  mobileNavOpen,
}) => {
  const navType = useSelector(selectNavType);
  const navData = useSelector(selectNavData);

  return (
    <NavBarContext.Provider value={isThemed}>
      <div
        className={`HeaderMain ${isThemed ? "Themed" : ""} ${
          mobileNavOpen ? "Open" : ""
        }`}
      >
        {navType === NavType.LOGIN ? (
          <LoginNavBar />
        ) : navType === NavType.LOGGED_IN ? (
          <LoggedInNavBar
            mobileNavOpen={mobileNavOpen}
            setMobileNavOpen={setMobileNavOpen}
          />
        ) : null}
      </div>
    </NavBarContext.Provider>
  );
};
